import { call, put, select, takeLatest } from "redux-saga/effects";
import { FETCH_SPOT_CONTACTS_BC_REQUEST, FetchSpotContactsBCFailure, FetchSpotContactsBCSuccess } from "../../actions/targetedReachout/spotContactBattleCardActions";
import { spotContactBC } from "../../../../services/iqApiV2";




// Worker Saga
function* fetchspotContactBCSaga() {
  try {
    const payload = yield select(
      (state) => state?.spotContactBCReducer?.payload
    );
    const { contactId } = payload;
    const data = yield call(
        spotContactBC,
        contactId
    );
    yield put(FetchSpotContactsBCSuccess(data));
  } catch (error) {
    yield put(FetchSpotContactsBCFailure(error.message));
  }
}

// Watcher Saga
export function* watchspotContactBCSaga() {
  yield takeLatest(FETCH_SPOT_CONTACTS_BC_REQUEST, fetchspotContactBCSaga);

}
